import { useNavigate } from "react-router-dom";
import ProductGrid from "../../components/store/ProductGrid";
import { useConfiguracionTiendaPublic } from "./hooks/useConfiguracionTiendaPublic";
import { useFavorites } from "./hooks/useFavorites";
import "./Store.css";

function Favoritos() {
  const navigate = useNavigate();
  const { configuracionTienda } = useConfiguracionTiendaPublic();
  const { favorites, ready, count, clear } = useFavorites();

  return (
    <div className="store-home-scope">
      <div className="store-home">
        <header
          className="store-home__head"
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            flexWrap: "wrap",
            gap: "12px",
          }}
        >
          <h1 className="store-home__title" style={{ margin: 0 }}>
            Favoritos{count > 0 ? ` (${count})` : ""}
          </h1>
          {count > 0 && (
            <button
              type="button"
              className="store-home__load-more"
              onClick={clear}
              style={{ marginBottom: "8px" }}
            >
              Vaciar lista
            </button>
          )}
        </header>

        {ready && count === 0 ? (
          <div className="store-home__state">
            Aún no tienes productos en tu lista de favoritos. Toca el corazón en
            cualquier producto para guardarlo aquí.
            <div className="store-home__load-more-wrap">
              <button
                type="button"
                className="store-home__load-more"
                onClick={() => navigate("/store/productos")}
              >
                Explorar productos
              </button>
            </div>
          </div>
        ) : (
          <div className="store-home__grid-wrap">
            <ProductGrid
              products={favorites}
              configuracionTienda={configuracionTienda}
              loading={!ready}
              skeletonCount={8}
              onSelect={(p) => navigate(`/store/product/${p.producto_id}`)}
            />
          </div>
        )}
      </div>
    </div>
  );
}

export default Favoritos;
